import { api } from './index';
import { Methods } from './interfaces';
import { PaymentCalculations, PriceConfig } from '@/types/salary';

interface GetSalaryReq {
  from: string;
  to: string;
  teacher?: string;
  priceConfig: PriceConfig;
}

interface GetSalaryRes {
  [teacher: string]: PaymentCalculations;
}

const getSalary = (options: GetSalaryReq) => {
  return api<GetSalaryReq, GetSalaryRes>({
    method: Methods.POST,
    route: '/salary',
    payload: options,
  });
};

const getExtraSalary = options => {
  return api<void, any>({
    method: Methods.GET,
    route: '/salary/extra',
    payload: options,
  });
};

const createExtraSalary = (options: any) => {
  return api<any, any>({
    method: Methods.POST,
    route: '/salary/extra',
    payload: options,
  });
};

const deleteExtraSalary = (id: string) => {
  return api<void, any>({
    method: Methods.DELETE,
    route: `/salary/extra/${id}`,
  });
};

const approveExtraSalary = (id: string) => {
  return api<void, any>({
    method: Methods.PATCH,
    route: `/salary/extra/${id}`,
  });
};

export const salaryApi = {
  getSalary,
  getExtraSalary,
  createExtraSalary,
  deleteExtraSalary,
  approveExtraSalary,
};
